import { AmplifyAudioRepository } from 'app/api/consult/repository/AudioRepository'
import { AmplifyCreateConsultRepository } from 'app/api/consult/repository/ConsultRepository'

export const consultRepository = new AmplifyCreateConsultRepository()
export const audioRepository = new AmplifyAudioRepository()
